import React, { Component } from 'react';
import { Card } from 'react-bootstrap';

import * as util from '../../library/utilitys';
class DashboardSummaryInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animatedValue: 0,
        };
    }

    componentDidMount() {
        this.animateValue(0, this.props.value || 0, 1000);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.animateValue(0, this.props.value || 0, 1000);
        }
    }

    animateValue = (start, end, duration) => {
        const startTime = performance.now();

        const step = (currentTime) => {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const currentValue = Math.floor(progress * (end - start) + start);
            this.setState({ animatedValue: currentValue });

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        };

        requestAnimationFrame(step);
    };

    formatNumber = (value) => {
        return value.toLocaleString(); 
    };

    render = () => {
        let { 
            title = "", 
            icon = "", 
            value = 0, 
            action, 
            variant = "primary" 
        } = this.props;

        const { animatedValue } = this.state;

        return (
            <Card className="card-wth-line">
                <div className={`card-line bg-${variant}`} />
                <Card.Body>
                    <Card.Title>
                        {icon && <i className={`${icon} me-2`}></i>}
                        {title}
                    </Card.Title>
                    <div className="d-flex justify-content-center align-items-center" style={{ maxHeight: '350px', position: 'relative' }}>
                        <div className={`avatar avatar-lg avatar-${variant} avatar-rounded`}
                            style={{
                                width: '120px',
                                height: '120px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '10px',
                                marginBottom: '10px'
                            }}                        
                        >
                            <span className="initial-wrap" style={{fontSize: '1.8rem'}} >{util.formatNumber(animatedValue)}</span>
                        </div>
                    </div>
                </Card.Body>
                {action && (
                    <Card.Footer className="p-2">
                        <div className="d-flex justify-content-center w-100">
                            <span className="small">{action}</span>
                        </div>
                    </Card.Footer>
                )}
            </Card>
        );
    };
}

export default DashboardSummaryInfo;
